module.exports = ":host{\n    margin: 15px;\n}"